import React, { FC } from 'react'

interface Props {
  size?: number
  fill?: string
  bordered?: boolean
}

export const ChatIconInspiration: FC<Props> = ({
  size = 28,
  bordered,
  fill = 'white',
}) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
    {bordered && (
      <rect width="28" height="28" rx="14" fill="white" fillOpacity="0.14" />
    )}
    <path
      d="M11.1226 12.6042C11.502 11.9106 12.498 11.9106 12.8774 12.6042L14.017 14.688C14.2005 15.0235 14.4765 15.2995 14.812 15.483L16.8958 16.6226C17.5894 17.002 17.5894 17.998 16.8958 18.3774L14.812 19.517C14.4765 19.7005 14.2005 19.9765 14.017 20.312L12.8774 22.3958C12.498 23.0894 11.502 23.0894 11.1226 22.3958L9.98299 20.312C9.79945 19.9765 9.52354 19.7005 9.18796 19.517L7.10418 18.3774C6.41063 17.998 6.41064 17.002 7.10418 16.6226L9.18796 15.483C9.52354 15.2995 9.79945 15.0235 9.98299 14.688L11.1226 12.6042Z"
      fill={fill}
    />
    <path
      d="M13.0613 4.80209C13.251 4.45532 13.749 4.45532 13.9387 4.80209L14.4201 5.68237C14.5119 5.85016 14.6498 5.98811 14.8176 6.07988L15.6979 6.56132C16.0447 6.75098 16.0447 7.24902 15.6979 7.43868L14.8176 7.92012C14.6498 8.01189 14.5119 8.14984 14.4201 8.31763L13.9387 9.19791C13.749 9.54468 13.251 9.54468 13.0613 9.19791L12.5799 8.31763C12.4881 8.14984 12.3502 8.01189 12.1824 7.92012L11.3021 7.43868C10.9553 7.24902 10.9553 6.75098 11.3021 6.56132L12.1824 6.07988C12.3502 5.98811 12.4881 5.85016 12.5799 5.68237L13.0613 4.80209Z"
      fill={fill}
    />
    <path
      d="M20.0613 7.80209C20.251 7.45532 20.749 7.45532 20.9387 7.80209L21.6331 9.07184C21.8167 9.40742 22.0926 9.68334 22.4282 9.86687L23.6979 10.5613C24.0447 10.751 24.0447 11.249 23.6979 11.4387L22.4282 12.1331C22.0926 12.3167 21.8167 12.5926 21.6331 12.9282L20.9387 14.1979C20.749 14.5447 20.251 14.5447 20.0613 14.1979L19.3669 12.9282C19.1833 12.5926 18.9074 12.3167 18.5718 12.1331L17.3021 11.4387C16.9553 11.249 16.9553 10.751 17.3021 10.5613L18.5718 9.86687C18.9074 9.68334 19.1833 9.40742 19.3669 9.07184L20.0613 7.80209Z"
      fill={fill}
    />
  </svg>
)
